import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1e18f2f1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list_container" }
const _hoisted_2 = { class: "list_title" }
const _hoisted_3 = { class: "table_columns" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  style: {"display":"flex","align-items":"center","justify-content":"center","padding":"48px 0"}
}
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"n-empty\" style=\"--n-icon-size:40px;--n-font-size:14px;--n-bezier:cubic-bezier(.4, 0, .2, 1);--n-text-color:rgba(255, 255, 255, 0.38);--n-icon-color:rgba(255, 255, 255, 0.38);--n-extra-text-color:rgba(255, 255, 255, 0.82);\" data-v-1e18f2f1><div class=\"n-empty__icon\" data-v-1e18f2f1><i class=\"n-base-icon\" data-v-1e18f2f1><svg viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" data-v-1e18f2f1><path d=\"M26 7.5C26 11.0899 23.0899 14 19.5 14C15.9101 14 13 11.0899 13 7.5C13 3.91015 15.9101 1 19.5 1C23.0899 1 26 3.91015 26 7.5ZM16.8536 4.14645C16.6583 3.95118 16.3417 3.95118 16.1464 4.14645C15.9512 4.34171 15.9512 4.65829 16.1464 4.85355L18.7929 7.5L16.1464 10.1464C15.9512 10.3417 15.9512 10.6583 16.1464 10.8536C16.3417 11.0488 16.6583 11.0488 16.8536 10.8536L19.5 8.20711L22.1464 10.8536C22.3417 11.0488 22.6583 11.0488 22.8536 10.8536C23.0488 10.6583 23.0488 10.3417 22.8536 10.1464L20.2071 7.5L22.8536 4.85355C23.0488 4.65829 23.0488 4.34171 22.8536 4.14645C22.6583 3.95118 22.3417 3.95118 22.1464 4.14645L19.5 6.79289L16.8536 4.14645Z\" fill=\"currentColor\" data-v-1e18f2f1></path><path d=\"M25 22.75V12.5991C24.5572 13.0765 24.053 13.4961 23.5 13.8454V16H17.5L17.3982 16.0068C17.0322 16.0565 16.75 16.3703 16.75 16.75C16.75 18.2688 15.5188 19.5 14 19.5C12.4812 19.5 11.25 18.2688 11.25 16.75L11.2432 16.6482C11.1935 16.2822 10.8797 16 10.5 16H4.5V7.25C4.5 6.2835 5.2835 5.5 6.25 5.5H12.2696C12.4146 4.97463 12.6153 4.47237 12.865 4H6.25C4.45507 4 3 5.45507 3 7.25V22.75C3 24.5449 4.45507 26 6.25 26H21.75C23.5449 26 25 24.5449 25 22.75ZM4.5 22.75V17.5H9.81597L9.85751 17.7041C10.2905 19.5919 11.9808 21 14 21L14.215 20.9947C16.2095 20.8953 17.842 19.4209 18.184 17.5H23.5V22.75C23.5 23.7165 22.7165 24.5 21.75 24.5H6.25C5.2835 24.5 4.5 23.7165 4.5 22.75Z\" fill=\"currentColor\" data-v-1e18f2f1></path></svg></i></div><div class=\"n-empty__description\" data-v-1e18f2f1>无数据</div></div>", 1)
const _hoisted_8 = [
  _hoisted_7
]

import { onMounted, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ListTable',
  props: {
  horizontal: {
    type: Boolean,
    default: false,
  },
  scroll: {
    type: Boolean,
    default: false,
  },
  tableColumns: {
    type: Array,
    default: () => [],
  },
  tableData: {
    type: Array,
    default: () => [],
  },
  maxHeight: {
    type: String,
    default: '',
  },
},
  emits: ['tableItemClick'],
  setup(__props, { emit: __emit }) {

const emit = __emit
function getstyle(row, item) {
  if (row[item.iscb]) return '#FF3030'
  if (
    row[item.key] == 'Ⅰ' ||
    row[item.key] == 'Ⅰ类' ||
    row[item.key] == 'Ⅱ类' ||
    row[item.key] == 'Ⅱ'
  ) {
    return '#41A5E6'
  } else if (row[item.key] == 'Ⅲ' || row[item.key] == 'Ⅲ类' || row[item.key] == '达标') {
    return '#00FF4E'
  } else if (row[item.key] == 'Ⅳ' || row[item.key] == 'Ⅳ类') {
    return '#FFD225'
  } else if (row[item.key] == 'Ⅴ' || row[item.key] == 'Ⅴ类') {
    return '#DD9090'
  } else if (row[item.key] == '劣Ⅴ' || row[item.key] == '劣Ⅴ类' || row[item.key] == '超标') {
    return '#FF3030'
  }
}
const props = __props
// 列表点击事件
function onTableItemClick(row) {
  emit('tableItemClick', row)
}

const listContent = ref(null)
const listContent2 = ref(null)
onMounted(() => {
  // if (props.scroll) {
  //   listContent2.value.innerHtml = listContent.value.innerHtml
  // }
})

return (_ctx: any,_cache: any) => {
  const _component_n_tooltip = _resolveComponent("n-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "list_title")
    ]),
    _renderSlot(_ctx.$slots, "list_filter"),
    _createElementVNode("div", {
      class: _normalizeClass(["list_content", __props.horizontal ? 'horizontal' : ''])
    }, [
      _createElementVNode("div", {
        style: _normalizeStyle({ width: __props.horizontal ? `${props.tableColumns.length * 120}px` : '100%' })
      }, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableColumns, (column) => {
            return (_openBlock(), _createElementBlock("div", {
              key: column.key,
              class: "columns_item",
              style: _normalizeStyle({ width: column.width || '100px' })
            }, _toDisplayString(column.label), 5))
          }), 128))
        ]),
        _createElementVNode("div", {
          class: "table_list",
          style: _normalizeStyle({
            maxHeight: props.maxHeight,
          })
        }, [
          (props.tableData.length>0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(props.scroll && props.tableData.length > 20 ? 'scroll' : ''),
                style: _normalizeStyle({ 'animation-duration': props.tableData.length * 2 + 's' })
              }, [
                _createElementVNode("div", {
                  ref_key: "listContent",
                  ref: listContent
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableData, (row) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: row.key,
                      class: "list_item",
                      onClick: ($event: any) => (onTableItemClick(row))
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableColumns, (item) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: item.key,
                          class: _normalizeClass(["row_item", {
                    text_just: item.isTextJust || false,
                  }]),
                          style: _normalizeStyle({ width: item.width || '100px' })
                        }, [
                          _createVNode(_component_n_tooltip, { trigger: "hover" }, {
                            trigger: _withCtx(() => [
                              _createElementVNode("div", {
                                style: _normalizeStyle({ color: getstyle(row, item) })
                              }, _toDisplayString(row[item.key] ? row[item.key] : '--'), 5)
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("div", {
                                class: "nowrap",
                                style: _normalizeStyle({
                        maxWidth: item.width || '100px',
                      })
                              }, _toDisplayString(row[item.key] ? row[item.key] : '--'), 5)
                            ]),
                            _: 2
                          }, 1024)
                        ], 6))
                      }), 128))
                    ], 8, _hoisted_4))
                  }), 128))
                ], 512),
                (props.scroll && props.tableData.length > 20)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      ref_key: "listContent2",
                      ref: listContent2
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableData, (row) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: row.key,
                          class: "list_item",
                          onClick: ($event: any) => (onTableItemClick(row))
                        }, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tableColumns, (item) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: item.key,
                              class: _normalizeClass(["row_item", {
                    text_just: item.isTextJust || false,
                  }]),
                              style: _normalizeStyle({ width: item.width || '100px' })
                            }, [
                              _createVNode(_component_n_tooltip, {
                                placement: "top-start",
                                trigger: "hover"
                              }, {
                                trigger: _withCtx(() => [
                                  _createElementVNode("div", {
                                    style: _normalizeStyle({ color: getstyle(row, item) })
                                  }, _toDisplayString(row[item.key] ? row[item.key] : '--'), 5)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: "nowrap",
                                    style: _normalizeStyle({
                        maxWidth: item.width || '100px',
                      })
                                  }, _toDisplayString(row[item.key] ? row[item.key] : '--'), 5)
                                ]),
                                _: 2
                              }, 1024)
                            ], 6))
                          }), 128))
                        ], 8, _hoisted_5))
                      }), 128))
                    ], 512))
                  : _createCommentVNode("", true)
              ], 6))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
        ], 4)
      ], 4)
    ], 2)
  ]))
}
}

})